export default "__VITE_ASSET__CBd36iLT__"